import { _ } from "i18n";
import { Keys } from "i18n/locales/types";
import { Row } from "react-table";
import { ActionsCell } from "./ActionsCell";
import { DieLigenApiManagementConstants } from "../../pages/productManagement/apiManagement/dieLigen/DieLigenApiManagementConstants";
import { Team, TeamsheetPlayerData } from "../../types/apiManagement";

export const TeamLabel: React.FC<{ team?: Team; status?: string }> = ({ team }) => {
    return (
        <div style={{ 
            fontSize: '14px', 
            color: team === 'home' ? '#2563eb' : '#dc2626',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
        }}>
            {team === 'home' ? 'Home Team' : 'Away Team'}
        </div>
    );
};

export const StatusDisplay: React.FC<{ status: string }> = ({ status }) => {
    return (
        <div style={{ 
            fontSize: '14px',
            color: status === DieLigenApiManagementConstants.Status.MAPPED ? '#10B981' : '#4B5563',
            fontWeight: status === DieLigenApiManagementConstants.Status.MAPPED ? 'bold' : 'normal',
            textAlign: 'center',
            width: '100%'
        }}>
            {status}
        </div>
    );
};

export const headerRenderers = {
    name: () => (
        <div style={{ fontWeight: 'bold' }}>
            {_("video-tasks.modal.teamsheet.table.name" as keyof Keys)}
        </div>
    ),
    status: () => (
        <div style={{ fontWeight: 'bold' }}>
            {_("video-tasks.modal.teamsheet.table.status" as keyof Keys)}
        </div>
    )
};

export const createCellRenderers = (
    onCreatePlayer: (player: TeamsheetPlayerData) => void,
    onMapPlayer: (player: TeamsheetPlayerData) => void,
) => ({
    name: ({ row }: { row: Row<TeamsheetPlayerData> }) => {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <TeamLabel team={row.original.data?.provider?.team} status={row.original.status} />
                <div>{row.original.data?.provider?.formattedName?.firstName} {row.original.data?.provider?.formattedName?.lastName}</div>
            </div>
        )
    },
    status: ({ row }: { row: Row<TeamsheetPlayerData> }) => {        
        return (
            <div>
                {row.original.status === 'not_mapped' 
                    ? <ActionsCell
                        actions={[
                            {
                                type: 'button',
                                label: "video-tasks.modal.teamsheet.create_action",
                                isTranslationKey: true,
                                className: "primary",
                                onClick: () => onCreatePlayer(row.original)
                            },
                            {
                                type: 'button',
                                label: "video-tasks.modal.teamsheet.map_action",
                                isTranslationKey: true,
                                className: "secondary",
                                onClick: () => onMapPlayer(row.original)
                            }
                        ]}
                      />
                    : <StatusDisplay status={row.original.status} />
                }
            </div>
        );
    }
}); 